// extracted by mini-css-extract-plugin
module.exports = {"footerStyle":"Footer_footerStyle__2JozB","footerContant":"Footer_footerContant__36sQm"};